import { always, equals, ifElse, propOr } from 'ramda';

import { measureNoWrappedText } from '../../../utils/measureText';
import { WIDTH_TYPES } from '../../../utils/constants';
import {
  CHART_BACKGROUND_COLOR,
  CHART_PALETTE,
  BAR_CHART_PALETTE_LIGHT,
  CHART_PALETTE_DARK,
  TRANSPARENT,
} from '../../../utils/colors';
import { sansSerfifFamily } from '../../layout/layout.styles';
import { tickStyle } from '../axes/axes.styles';
import { STROKE_STYLE } from '../charts.constants';

export const BAR_DEFAULT = {
  legendVisibility: true,
  titlesVisibility: true,
  // GRID
  gridVisible: true,
  gridBackground: CHART_BACKGROUND_COLOR,
  gridRowLineStyle: STROKE_STYLE,
  gridColumnLineStyle: STROKE_STYLE,
  // AXES
  xAxisVisible: true,
  xAxisSpace: 20,
  yAxisVisible: true,
  yAxisSpace: 40,
  // BAR PADDING
  padding: 0,
  groupPadding: 0,
  // COLORS
  colors: CHART_PALETTE,
};

export const WITH_PADDING = {
  padding: 0.1,
  groupPadding: 0.3,
};

export const NO_AXES = {
  xAxisVisible: false,
  yAxisVisible: false,
};

export const NO_GRID = {
  gridVisible: false,
  gridBackground: TRANSPARENT,
};

export const getVerticalBarConfig = (type) => {
  const condConfig = ifElse(
    equals(WIDTH_TYPES.SHORT),
    always({
      gridBackground: TRANSPARENT,
      colors: BAR_CHART_PALETTE_LIGHT,
    }),
    always({
      colors: CHART_PALETTE_DARK,
    })
  )(type);

  return {
    ...condConfig,
    groupPadding: 0.1,
    chartHeight: 300,
  };
};

export const getHorizontalBarConfig = (type, { axis, data, series }) => {
  const labelsWidths = data.map((item) => {
    const label = item[axis];

    const { width } = measureNoWrappedText(label, {
      ...tickStyle,
      fontFamily: sansSerfifFamily,
    });

    return width;
  });

  const countData = data.length;
  const countSeries = series.filter((serie) => !serie.match(/c\d+/g)).length;

  return {
    ...getVerticalBarConfig(type),
    xAxisSpace: Math.max(...labelsWidths),
    chartHeight: Math.max(200, countData * countSeries * 20),
  };
};

export const getVerticalStackConfig = (type) => {
  const condConfig = ifElse(
    equals(WIDTH_TYPES.SHORT),
    always({
      gridBackground: TRANSPARENT,
    }),
    always({})
  )(type);

  return {
    ...condConfig,
    padding: 0.2,
    colors: BAR_CHART_PALETTE_LIGHT,
  };
};

export const getHorizontalStackConfig = (type, { axis, data }) => {
  const labelsWidths = data.map((item) => {
    const label = item[axis];

    const measurements = measureNoWrappedText(label, {
      ...tickStyle,
      fontFamily: sansSerfifFamily,
    });

    return propOr(BAR_DEFAULT.xAxisSpace, 'width', measurements);
  });

  const countData = data.length;

  return {
    ...getVerticalStackConfig(type),
    xAxisSpace: Math.max(...labelsWidths),
    chartHeight: Math.max(200, countData * 20),
  };
};
